import { Button, Tooltip, TooltipProps } from '@mui/material';
import React from 'react';
import styled from 'styled-components';

interface IStyledButtonWithToolTipProps  {
  marginRight: string;
}

export const StyledButtonWithTooltip = styled(Button)<IStyledButtonWithToolTipProps>`
${({ theme, marginRight }) => `
  &.MuiButton-root {
    margin-right: ${marginRight? '12px' : ''};
    text-transform: uppercase;
    font-family:  ${theme.fonts.primary}${theme.uptimeFonts.secondary && `,${theme.uptimeFonts.secondary}`} !important;
    font-size: ${theme.uptimeFontSizes.desktop.fz2}px;
    font-weight: 600;
    padding: ${theme.uptimeSpace[2]}px ${theme.uptimeSpace[4]}px;
    border-radius: ${theme.uptimeSpace[4]}px;
  }
  &.MuiButton-outlined {
    color: ${theme.uptimeColors.mainTheme.secondary};
    background-color: ${theme.colors.grayScale[0]} !important;
    &:hover {
      border-color: ${theme.uptimeColors.mainTheme.secondary};
    }
  }
`}`;

const ToBeStyledTooltip = (props: TooltipProps) => (
  <Tooltip classes={{ popper: props.className }} {...props} />
);

export const StyledTooltip = styled(ToBeStyledTooltip)(({ theme }) => `
  & .MuiTooltip-tooltip {
    padding: ${theme.uptimeSpace[3]}px ${theme.uptimeSpace[8]}px;
    background-color: ${theme.colors.grayScale[10]};
    font-size: ${theme.uptimeFontSizes.desktop.fz2}px;
  }
  & .MuiTooltip-arrow{
    color: ${theme.colors.grayScale[10]};
  }
`);
